import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';


import {HttpClient, HttpParams} from '@angular/common/http';
import {DirectorySearchResponse} from '../../types/wsdirectory/directory-search-response';
import {BaseRestService} from '../common/BaseRestService';

@Injectable()
export class DirectorySearchRestService extends BaseRestService {

  constructor(private http: HttpClient) {
    super('directory');
  }


  search(searchOpts): Observable<DirectorySearchResponse> {
    let params: HttpParams = new HttpParams();

    Object.keys(searchOpts).forEach(key => {
      if (key === 'officialNso') {
        params = params.set(key, searchOpts.officialNso);
      }
      if (searchOpts[key]) {
        params = params.set(key, searchOpts[key]);
      }
    });

    return this.http.get<DirectorySearchResponse>(this.getEndpoint(['search']), {params});
  }

}
